import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Avatar, Box, Button, Dialog, Fade, Typography } from "@mui/material";
import { alpha } from '@mui/material/styles';

const DiscardChangesModal = ({
    open,
    onClose,
    onDiscard
}) => (
    <Dialog
        open={open}
        onClose={(event, reason) => {
            if (reason !== "backdropClick") {
                onClose(event, reason);
            }
        }}
        TransitionComponent={Fade}
        transitionDuration={400}
        PaperProps={{
            sx: {
                borderRadius: 2,
                boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                overflow: 'hidden',
                maxWidth: '420px',
                width: '100%',
                m: { xs: 1, sm: 2 },
            }
        }}
        sx={{ backdropFilter: "blur(5px)" }}
        aria-labelledby="discard-modal-title"
        aria-describedby="discard-modal-description"
    >
        {/* Top accent bar */}
        <Box sx={{
            height: 4,
            width: '100%',
            background: 'linear-gradient(90deg, #f44336 0%, #b71c1c 100%)'
        }} />

        <Box sx={{ pt: 4, pb: 2, px: { xs: 2, sm: 3 } }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                <Avatar sx={{
                    bgcolor: alpha('#f44336', 0.1),
                    color: '#f44336',
                    mr: 2
                }}>
                    <InfoOutlinedIcon />
                </Avatar>
                <Typography
                    id="discard-modal-title"
                    variant="h6"
                    fontWeight={700}
                    color="text.primary"
                >
                    Discard Unsaved Changes?
                </Typography>
            </Box>

            <Typography
                id="discard-modal-description"
                variant="body2"
                sx={{ lineHeight: 1.6, color: 'black', fontSize: "14px", mb: 3 }}
            >
                You have unsaved changes. Are you sure you want to discard them? This action cannot be undone.
            </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 1 }}>
                <Button
                    variant="outlined"
                    onClick={onClose}
                    sx={{
                        px: 3,
                        py: 1,
                        borderColor: '#bdbdbd',
                        color: '#555',
                        fontWeight: 500,
                        bgcolor: 'white',
                        '&:hover': {
                            borderColor: '#757575',
                            bgcolor: 'rgba(0,0,0,0.03)'
                        }
                    }}
                >
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    onClick={onDiscard}
                    sx={{
                        px: 3,
                        py: 1,
                        bgcolor: '#f44336',
                        color: '#fff',
                        fontWeight: 600,
                        boxShadow: 'none',
                        '&:hover': {
                            bgcolor: '#b71c1c'
                        }
                    }}
                >
                    Discard Changes
                </Button>
            </Box>
        </Box>
    </Dialog>
);

export default DiscardChangesModal;